<template>
    <div class="xiangmjiangli">
        <div class="banner"></div>
        <div class="content">
            <div class="top">
                <p class="iconfont icon-24gl-clockCircle pp1"> {{time}}</p>
                <p class="title">
                    <span class="span1">前端低代码开发实习生</span>
                    <span class="span2">3500 — 5000 元</span>
                </p>
                <p class="info">
                    <span class="span3">所属部门：技术研发部</span>
                    <span class="span4">江苏省&nbsp;&nbsp;|&nbsp;&nbsp;3不限&nbsp;&nbsp;|&nbsp;&nbsp;专科&nbsp;&nbsp;|&nbsp;&nbsp;实习&nbsp;&nbsp;|&nbsp;&nbsp;2人&nbsp;&nbsp;</span>
                </p>
            </div>  
            <div class="neirong">
                <p class="p1">职位描述:</p>
                <p class="p2"></p>
                <p class="p3">岗位职责:</p>
                <p class="p4">1、根据客户经理反馈的客户方需求安排实施进程，从而推进项目顺利进行；</p>
                <p class="p4">2、编写相关实施文档；</p>
                <p class="p4">3、为客户现场演示产品，并搭建使用环境；</p>
                <p class="p4">4、对客户进行产品操作使用培训，指导客户有效使用产品；；</p>
                <p class="p4">5、负责解决产品使用期间客户遇到的问题，为客户做出细致的解答，维护客户关系，提高客户满意度。 </p>
                <p class="p3 p33">岗位职要求:</p>
                <p class="p4">1、大专及以上学历，计算机相关专业；</p>
                <p class="p4">2、掌握mysql、oracle数据库操作；</p>
                <p class="p4">3、了解javascript、Css,Vue等前端技术；</p>
                <p class="p4">4、具有强烈的责任心、服务意识和团队合作精神，良好的沟通以及学习能力，能接受偶尔加班和出差；</p>
                <p class="p4">5、了解宜搭或有宜搭实施、相关实施工作经验者优先；</p>
                <p class="p4">6、良好的学习能力、沟通能力、表达能力和分析解决问题能力，拥有强烈的进取心和对工作高度的责任感及良好的团队合作精神。</p>

                <p class="p3 p33">福利待遇:</p>
                <p class="p4">1、公司提供带薪培训；</p>
                <p class="p4">2、丰富的员工活动（各类员工活动、部门聚会、月会、员工生日会、旅游等）；</p>
                <p class="p4">3、薪资：试用期3500—5000，转正后根据工作表现和能力重新定；</p>
                <p class="p4"><span class="teshu">其他福利&nbsp;：</span> 朝九晚六，双休，五险一金，法定节假日；带薪年假+生日福利+节假日福利。</p>

                <p class="p4 ps"><span class="teshu">联系电话&nbsp;:</span>&nbsp; 18952039164</p>
                <p class="p4"><span class="teshu">简历邮箱&nbsp;:</span>&nbsp; 624054484@qq.com</p>
                <p class="p4"><span class="teshu">地址&nbsp;: </span>&nbsp; 南京市建邺区国家广告产业园5栋706室</p>
            </div>  
        </div>
    </div>
</template>
        
<script>
export default {
    data () {
        return {
            time:""
        }
    },
   mounted () {
        var now = new Date();  
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        this.time = year + "-" + month + "-" + date;    //（格式化"yyyy-MM-dd"）   
   }
}
</script>
<style lang='less' scoped>
.xiangmjiangli{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 264px;
        background-image: url("http://img601.yun300.cn/repository/image/10d45510-d4b3-42db-964d-4a1718d44ced.jpg?tenantId=214689&viewType=1&k=1651226704000");
        background-size: 100%;
        background-repeat: no-repeat;
    }  
    .content{
        width: 66%;
        margin: 50px auto 20px;
        .top{
            width: 100%;
            height: 165px;
            box-sizing: border-box;
            padding: 10px 40px 30px;
            background-color: #fbfcfd;
            .pp1{
                color: #666;
            }
            .title{
                height: 70px;
                color: #000;
                .span1{
                    font-size: 38px;
                    line-height: 70px;
                }
                .span2{
                    color: #ff5959;
                    font-weight: bold;
                    font-size: 30px;
                    line-height: 70px;
                    float: right;
                }
            }
            .info{
                margin-top: 10px;
                .span3{
                    font-size: 14px;
                    color: #999;
                    height: 20px;
                    line-height: 20px;
                }
                .span4{
                    font-size: 14px;
                    color: #999;
                    float: right;
                    margin-right: 40px;
                }
            }
        }
        .neirong{
            width: 100%;
            padding: 25px;
            box-sizing: border-box;
            .p1{
                font-size: 16px;
                color: #333;
                line-height: 40px;
            }
            .p2{
                width: 21px;
                height: 2px;
                background-color: #04abf4;
            }
            .p3{
                height: 36px;
                line-height: 36px;
                font-size: 15px;
                color: #333;
                font-weight: bold;
                margin-top: 18px;
            }
            .p4{
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                color: #333;
            }
            .p33{
                margin-top: 30px;
            }
            .teshu{
                line-height: 36px;
                font-size: 15px;
                color: #333;
                font-weight: bold;
            }
            .ps{
                margin-top: 36px;
            }
        }
    }
}
</style>